import { useContext } from 'react';
import { CmsTextsContext } from '../providers/CmsTextsContext';
export function useCmsTexts() {
    const [state, dispatch] = useContext(CmsTextsContext);
    const cmsTexts = state.texts;
    const substitute = (str, data) => {
        return (str === null || str === void 0 ? void 0 : str.replace(/%[^%]+%/g, match => data[match] || '')) || '';
    };
    const getCmsText = (input, optionalData) => {
        if (cmsTexts && optionalData)
            return substitute(cmsTexts[input], optionalData);
        else if (cmsTexts)
            return cmsTexts[input];
    };
    return {
        cmsTextState: state,
        setCmsTextState: dispatch,
        getCmsText: getCmsText,
    };
}
